module.exports = __webpack_public_path__ + "img/Strategy.7dc99913.png";